import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Grid, Typography } from '@mui/material';
import { CustomizedSwitch } from 'components/arbor-switch/arbor-switch';
import { buildQaId } from 'utils/build-qa-id';
import { ApplicationManagerClient } from 'clients/application-manager-client';
import { fetchCustomers } from 'actions/action-filters';
import { useDispatch } from 'react-redux';
import { UserUtils } from 'utils/user-utils';
import { UserPermissions } from 'interfaces/user/Permissions';
import { useTypedSelector } from '../../../hooks/use-typed-selector';
import { SectionTitleStyled } from '../components/section-title';
import { cpStyle } from './index.styles';

enum StatusType {
  StatusOn = 'Status On',
  StatusOff = 'Status Off',
}
const getQaId = buildQaId('application-manager.ar-automatic-process', '.');

export const ArAutomaticProcess = (props: any): JSX.Element => {
  const { classes } = props;
  const dispatch = useDispatch();

  const [reloadDataTrigger, setReloadDataTrigger] = React.useState<Date | undefined>(undefined);
  const customers = useTypedSelector(state => state.filters.customers || []);
  const user = useTypedSelector(state => state.auth.currentUser);
  const stateSelectedCustomerId = useTypedSelector(state => state.filters.selectedCustomerId);

  const updateArAutomaticProcess = (customerId: number, arAutomaticProcessValue: boolean) => {
    ApplicationManagerClient.editCustomerAutomaticProcess(customerId, arAutomaticProcessValue).then(
      res => {
        dispatch(fetchCustomers());
        setReloadDataTrigger(new Date());
      },
    );
  };

  const userHasPermissionToEditArAutomaticProcess = React.useMemo<boolean>(() => {
    return UserUtils.userIsPermitted(UserPermissions.ArAutomaticProcess, stateSelectedCustomerId);
  }, [user]);

  return (
    <>
      <SectionTitleStyled title="AR Automatic Process" />
      <Grid container direction="column" spacing={1}>
        {customers.map(item => (
          <React.Fragment key={item.id}>
            <Grid container direction="row" alignItems="center" style={{ paddingBottom: '10px' }}>
              <Grid item xs={9}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  style={{ paddingBottom: '10px', borderBottom: 'thin solid #dedede' }}
                >
                  <Grid item xs={9}>
                    <Typography>{item.name}</Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <CustomizedSwitch
                      onClick={e => e.stopPropagation()}
                      checked={item.ar_automatic_process}
                      onChange={e => {
                        updateArAutomaticProcess(item.id, e.target.checked);
                      }}
                      disabled={!userHasPermissionToEditArAutomaticProcess}
                      data-qa-id={getQaId(item.id.toString())}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  className={
                    item.ar_automatic_process ? classes.statusOnColor : classes.statusOffColor
                  }
                >
                  {item.ar_automatic_process ? StatusType.StatusOn : StatusType.StatusOff}
                </Typography>
              </Grid>
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </>
  );
};

export default withStyles(cpStyle)(ArAutomaticProcess);
